import React, { Component } from 'react';

import Button from 'components/common/Button/Button';
import Checkbox from 'components/common/Checkbox/Checkbox';

import cn from 'classnames';
import styles from './BuildingClass.scss';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

const variants = {
  1: { param: '1', key: '1', text: i18n.t('components.header.filtersBar.filters.buildingClass.variant1'), event: 'Web_Filters_Economy' },
  2: { param: '2', key: '2', text: i18n.t('components.header.filtersBar.filters.buildingClass.variant2'), event: 'Web_Filters_Comfort' },
  3: { param: '3', key: '3', text: i18n.t('components.header.filtersBar.filters.buildingClass.variant3'), event: 'Web_Filters_Business' },
  4: { param: '4', key: '4', text: i18n.t('components.header.filtersBar.filters.buildingClass.variant4'), event: 'Web_Filters_Elite' }
};

export const parseSearch = (search) => {
  const { buildingClass } = search;
  if (!buildingClass) {
    return { buildingClass: [] };
  }
  const keys = buildingClass.split(',');
  return {
    buildingClass: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.param)) {
          prev.push(variant.key);
        }
        return prev;
      }, [])
  };
};

export const compileSearch = (data) => {
  const { buildingClass: keys } = data;
  if (!keys.length) {
    return { buildingClass: undefined };
  }

  return {
    buildingClass: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.param);
        }
        return prev;
      }, [])
      .join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { buildingClass } = data;
  return { buildingClass: buildingClass.length ? buildingClass : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { buildingClass: keys } = parseSearch(search);
  return Object.keys(variants)
    .reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.key)) {
        prev.push(variant.text);
      }
      return prev;
    }, [])
    .join(', ') || i18n.t('components.header.filtersBar.filters.buildingClass.notSelected');
};

class BuildingClass extends Component {

  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { dropdownData, mode, profile, objectType } = this.props;
    const data = { buildingClass: [] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick('building');

    trackGA(gaEvent.filterClearButtonsClick({
      eventContent: 'eshchyo',
      eventContext: mode,
      productType: objectType,
      user_id: profile.id
    }));
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData, mode, objectType, profile } = this.props;
    const { buildingClass: keys } = parseSearch(search);
    const buildingClass = [...keys];

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    const variant = variants[Object.keys(variants).find(v => variants[v].key === key)];
    const variantName = variant ? variant.text : 'Unknown variant';
    const isChecked = add ? 'on' : 'off';

    trackGA(gaEvent.filterCheckboxesClick({
      eventContent: [variantName, ` | ${isChecked}`],
      eventContext: mode,
      productType: objectType,
      user_id: profile.id
    }));

    if (buildingClass.includes(key) !== add) {
      if (add) {
        buildingClass.push(key);
      } else {
        buildingClass.splice(buildingClass.indexOf(key), 1);
      }
    }

    const data = { buildingClass };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, additional } = this.props;
    const { buildingClass } = parseSearch(search);
    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={buildingClass.includes(variant.key)}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        additional={additional}
        text={variant.text}
      />
    );
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { buildingClass } = parseSearch(search);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>

          {t('components.header.filtersBar.filters.buildingClass.title')}
          {!additional ? (
              !!buildingClass.length &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.buildingClass.clear')}
              </Button>
          ) : (null)}
        </p>
        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {this.checkbox('1')}
            {this.checkbox('2')}
          </div>
          <div className={styles.SecondColumn}>
            {this.checkbox('3')}
            {this.checkbox('4')}
          </div>
        </div>
        {additional ? (
          <div className={styles.ButtonWrap}>
            {!!buildingClass.length &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.buildingClass.clear')}
              </Button>}
          </div>
        ) : (null)}
      </div>
    );
  }
}

export default withTranslation(BuildingClass);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/BuildingClass/BuildingClass.js